export enum StripeStatus {
    CANCELED = 'canceled',
    SUCCEEDED = 'succeeded',
}
